module.exports = __webpack_public_path__ + "img/depthMap-enterprise240.69da5e85.png";